import getTeleradiologistPayouts from '@custom/rtk-apis/teleradiologistPayouts/getTeleRadiologistPayouts';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: ""
};

const teleradiologistPayoutsSlice = createSlice({
  name: 'teleradiologistPayouts',
  initialState,
  reducers: {
    resetTeleradiologistPayouts: (state) => {
      state.status = "";
      state.result = null;
      state.msg = "";
      state.loading = false;
      state.error = "";
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getTeleradiologistPayouts.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTeleradiologistPayouts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(getTeleradiologistPayouts.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload as string;
      });
  }
});

export default teleradiologistPayoutsSlice.reducer;
export const { resetTeleradiologistPayouts } = teleradiologistPayoutsSlice.actions;
